export default __webpack_public_path__ + "static/media/awards.22f66a87.svg";